export const MENU_ITEMS = [
  {
    id: 'dashboard',
    icon: '📊',
    path: '/dashboard',
    module: 'dashboard',
    submenu: []
  },
  {
    id: 'drivers',
    icon: '👤',
    path: '/drivers',
    module: 'drivers',
    submenu: [
      { id: 'drivers-list', path: '/drivers/filter', icon: '📋' },
      { id: 'drivers-add', path: '/drivers/add', icon: '➕' },
      { id: 'drivers-active', path: '/drivers/active', icon: '✅' },
      { id: 'drivers-inactive', path: '/drivers/inactive', icon: '❌' }
    ]
  },
  {
    id: 'vehicles',
    icon: '🚗',
    path: '/vehicles',
    module: 'vehicles',
    submenu: [
      { id: 'vehicles-list', path: '/vehicles/filter', icon: '📋' },
      { id: 'vehicles-add', path: '/vehicles/add', icon: '➕' },
      { id: 'vehicles-active', path: '/vehicles/active', icon: '✅' },
      { id: 'vehicles-inactive', path: '/vehicles/inactive', icon: '❌' }
    ]
  },
  {
    id: 'trips',
    icon: '📍',
    path: '/trips',
    module: 'trips',
    submenu: [
      { id: 'trips-list', path: '/trips/filter', icon: '📋' },
      { id: 'trips-add', path: '/trips/add', icon: '➕' }
    ]
  },
  {
    id: 'devices',
    icon: '📱',
    path: '/devices',
    module: 'devices',
    submenu: [
      { id: 'devices-list', path: '/devices/filter', icon: '📋' },
      { id: 'devices-add', path: '/devices/add', icon: '➕' },
      { id: 'devices-active', path: '/devices/active', icon: '✅' },
      { id: 'devices-inactive', path: '/devices/inactive', icon: '❌' }
    ]
  },
  {
    id: 'device-types',
    icon: '📲',
    path: '/device-types',
    module: 'device_types',
    submenu: [
      { id: 'devicetypes-list', path: '/device-types', icon: '📋' },
      { id: 'devicetypes-add', path: '/device-types/add', icon: '➕' }
    ]
  },
  {
    id: 'events',
    icon: '⚡',
    path: '/events',
    module: 'events',
    submenu: [
      { id: 'events-list', path: '/events/filter', icon: '📋' },
      { id: 'events-add', path: '/events/add', icon: '➕' }
    ]
  },
  {
    id: 'event-types',
    icon: '🔔',
    path: '/event-types',
    module: 'event_types',
    submenu: [
      { id: 'eventtypes-list', path: '/event-types', icon: '📋' },
      { id: 'eventtypes-add', path: '/event-types/add', icon: '➕' }
    ]
  },
  {
    id: 'orientation-types',
    icon: '🧭',
    path: '/orientation-types',
    module: 'orientation_types',
    submenu: [
      { id: 'orientation-list', path: '/orientation-types', icon: '📋' },
      { id: 'orientation-add', path: '/orientation-types/add', icon: '➕' }
    ]
  },
  {
    id: 'users',
    icon: '👥',
    path: '/users',
    module: 'users',
    submenu: [
      { id: 'users-list', path: '/users', icon: '📋' },
      { id: 'users-add', path: '/users/add', icon: '➕' }
    ]
  },
  {
    id: 'files',
    icon: '📁',
    path: '/files',
    module: 'files',
    submenu: [
      { id: 'files-list', path: '/files/filter', icon: '📋' }
    ]
  },
  {
    id: 'file-types',
    icon: '📄',
    path: '/file-types',
    module: 'file_types',
    submenu: [
      { id: 'filetypes-list', path: '/file-types', icon: '📋' },
      { id: 'filetypes-add', path: '/file-types/add', icon: '➕' }
    ]
  },
  {
    id: 'videos',
    icon: '🎥',
    path: '/videos',
    module: 'videos',
    submenu: [
      { id: 'videos-list', path: '/videos/filter', icon: '📋' },
      { id: 'videos-add', path: '/videos/add', icon: '➕' }
    ]
  },
  {
    id: 'trip-gps',
    icon: '🛰️',
    path: '/trip-gps',
    module: 'trip_gps',
    submenu: [
      { id: 'tripgps-list', path: '/trip-gps/filter', icon: '📋' },
      { id: 'tripgps-add', path: '/trip-gps/add', icon: '➕' }
    ]
  },
  {
    id: 'statistics',
    icon: '📊',
    path: '/statistics',
    module: 'statistics',
    submenu: []
  }
];

export const API_ENDPOINTS = {
  // Authentication
  LOGIN: '/api/auth/login',
  
  // Drivers
  DRIVERS: '/api/drivers',
  DRIVERS_FILTER: '/api/drivers/filter',
  DRIVER_BY_ID: (id) => `/api/drivers/${id}`,
  DRIVER_TRIPS: (id) => `/api/drivers/${id}/trips`,
  DRIVER_TRIPS_RANGE: (id) => `/api/drivers/${id}/trips/details`,
  
  // Vehicles
  VEHICLES: '/api/vehicles',
  VEHICLES_FILTER: '/api/vehicles/filter',
  VEHICLE_BY_ID: (id) => `/api/vehicles/${id}`,
  VEHICLE_TRIPS: (id) => `/api/vehicles/${id}/trips`,

  // Trips
  TRIPS: '/api/trips',
  TRIPS_FILTER: '/api/trips/filter',
  TRIP_BY_ID: (id) => `/api/trips/${id}`,
  TRIP_DETAILS: (id) => `/api/trips/${id}/details`,
  
  // Devices
  DEVICES: '/api/devices',
  DEVICES_FILTER: '/api/devices/filter',
  DEVICE_BY_ID: (id) => `/api/devices/${id}`,
  
  // Device Types
  DEVICE_TYPES: '/api/device-types',
  DEVICE_TYPE_BY_ID: (id) => `/api/device-types/${id}`,
  
  // Events
  EVENTS: '/api/events',
  EVENTS_FILTER: '/api/events/filter',
  EVENT_BY_ID: (id) => `/api/events/${id}`,
  
  // Event Types
  EVENT_TYPES: '/api/event-types',
  EVENT_TYPE_BY_ID: (id) => `/api/event-types/${id}`,
  
  // Orientation Types
  ORIENTATION_TYPES: '/api/orientation-types',
  ORIENTATION_TYPE_BY_ID: (id) => `/api/orientation-types/${id}`,
  
  // Users
  USERS: '/api/users',
  USERS_FILTER: '/api/users/filter',
  USER_BY_ID: (id) => `/api/users/${id}`,
  USER_ROLES: (id) => `/api/users/${id}/roles`,
  USER_RESET_PASSWORD: (id) => `/api/users/${id}/reset-password`,
  USER_CHANGE_PASSWORD: (id) => `/api/users/${id}/change-password`,

  // Roles
  ROLES: '/api/roles',
  ROLE_BY_ID: (id) => `/api/roles/${id}`,
  
  // Permissions
  PERMISSIONS: '/api/permissions',
  PERMISSION_BY_ID: (id) => `/api/permissions/${id}`,
  
  FILES: '/api/files',
  FILES_FILTER: '/api/files/filter',
  FILE_BY_ID: (id) => `/api/files/${id}`,
  
  // File Types
  FILE_TYPES: '/api/file-types',
  FILE_TYPE_BY_ID: (id) => `/api/file-types/${id}`,
  
  // Videos
  VIDEOS: '/api/videos',
  VIDEOS_FILTER: '/api/videos/filter',
  VIDEO_BY_ID: (id) => `/api/videos/${id}`,
  
   // Trip GPS
  TRIP_GPS: '/api/trip-gps',
  TRIP_GPS_FILTER: '/api/trip-gps/filter',
  TRIP_GPS_BY_ID: (id) => `/api/trip-gps/${id}`,

  // Crypto
  CRYPTO_PUBLIC_KEY: '/crypto/public-key',
  CRYPTO_DECRYPT: (id) => `/crypto/decrypt-file/${id}`
};